var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2751",
    "data-name": "Group 2751",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.491,
    height: 11.201,
    viewBox: "0 0 20.491 11.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M0,.7,10.245,9.306,20.491.7,17.4-1.894,10.245,4.118,3.089-1.894Z",
    transform: "translate(0 1.894)",
    fill: "#15355c"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.4ada7c10ab7932b33cc4054ed66819c5.svg";
export { ForwardRef as ReactComponent };